module.exports = __webpack_public_path__ + "static/img/弹窗.c5e05ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/弹窗.png
// module id = ipp6
// module chunks = 19